import { useEffect, useState } from "react";

import { useAuditLogContext } from "@ryde/redux";

import { useEntityNestedCommand } from "./entity-nested-command.context";

/** `isCollapsed` is true while the node is open. Follows search, the drawer's expand all and the row's own command. */
export const useEntityPropertyCollapse = (
  hasChildren: boolean,
): { isCollapsed: boolean; onToggle: () => void } => {
  const { searchValue, keySearchValue, expandAllNested, expandAllVersion } =
    useAuditLogContext();
  const { isExpanded: isRowExpanded, version: rowVersion } =
    useEntityNestedCommand();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const shouldAutoExpand =
    hasChildren && (!!searchValue.trim() || !!keySearchValue?.trim());

  useEffect(() => {
    if (shouldAutoExpand || expandAllNested) {
      setIsCollapsed(true);
    } else if (expandAllNested === false) {
      setIsCollapsed(false);
    }
  }, [shouldAutoExpand, expandAllNested, expandAllVersion]);

  useEffect(() => {
    if (rowVersion > 0 && isRowExpanded !== undefined) {
      setIsCollapsed(isRowExpanded);
    }
  }, [isRowExpanded, rowVersion]);

  return { isCollapsed, onToggle: () => setIsCollapsed(prev => !prev) };
};
